import {
  Component,
  EventEmitter,
  Input,
  Output,
  WritableSignal,
  signal,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { Store } from '@app/config/store';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { GlobalSearchResult } from '@app/types/global.type';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import {
  matArrowCircleLeftOutline,
  matWidthFullOutline,
  matDashboardOutline,
  matReceiptLongOutline,
  matArrowCircleRightOutline,
} from '@ng-icons/material-icons/outline';
import {
  matConstruction,
  matWarningAmber,
  matStackedLineChart,
} from '@ng-icons/material-icons/baseline';
import { NgStyle } from '@angular/common';

export type Menu = {
  title: string;
  icon: string;
  collapse?: boolean;
  class?: string;
  flyout?: Menu[];
  menu?: Menu[];

  route?: string;
  click?: () => void;
};

@Component({
  selector: 'app-sidenav, [app-sidenav]',
  standalone: true,
  templateUrl: './sidenav.component.html',
  styleUrl: './sidenav.component.css',
  imports: [RouterModule, ReactiveFormsModule, NgStyle, NgIconComponent],
  viewProviders: [
    provideIcons({
      matArrowCircleLeftOutline,
      matArrowCircleRightOutline,
      matWidthFullOutline,
      matDashboardOutline,
      matConstruction,
      matWarningAmber,
      matStackedLineChart,
      matReceiptLongOutline,
    }),
  ],
})
export class SidenavComponent {
  @Input() app!: { name: string; icon: string };
  @Input() menu!: Menu[];
  @Input() search: boolean = false;
  @Input() searchResults: GlobalSearchResult[] = [];
  @Output() resultEvent = new EventEmitter<string>();
  @Output() searchAction = new EventEmitter<GlobalSearchResult>();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  hoveredFlyout: null | any = null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  hideTimeout: any;
  minimized: WritableSignal<boolean> = signal(false);
  searchText = new FormControl('');

  searchModalVisible: boolean = false;

  constructor(protected store: Store) {}

  toggleMenu() {
    this.store.miniSidenav.update((val) => !val);
    localStorage.setItem('miniSidebar', this.store.miniSidenav().toString());
  }

  toggleGroupMenu(index: number) {
    this.menu[index].collapse = !this.menu[index].collapse;
    this.menu = [...this.menu]; // force rerendering of the component
  }

  openSearch() {
    this.searchModalVisible = true;
  }

  handleSearch() {
    this.resultEvent.emit(this.searchText.value ?? '');
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onResultAction(item: any) {
    this.searchAction.emit(item);

    this.searchModalVisible = false;
    this.searchResults = [];
    this.searchText.patchValue('');
  }

  showFlyout(item: Menu, event: MouseEvent) {
    if (!item.flyout) {
      this.hoveredFlyout = null;
      return;
    }
    clearTimeout(this.hideTimeout);
    const target = event.currentTarget as HTMLElement;
    const rect = target.getBoundingClientRect();
    this.hoveredFlyout = {
      item,
      top: rect.top,
      left: rect.right,
    };
  }

  hideFlyoutWithDelay() {
    clearTimeout(this.hideTimeout);
    this.hideTimeout = setTimeout(() => {
      this.hoveredFlyout = null;
    }, 200);
  }

  hideFlyout() {
    clearTimeout(this.hideTimeout);
    this.hoveredFlyout = null;
  }
}
